// @flow
import Raven from "raven-js"

if (!__DEV__) {
  const sentryUrl = window.SP_GLOBALS.IS_STAGING
    ? "https://f93e120fbc024618815b2da199dd140f@sentry.skypicker.com/33"
    : "https://8c1d6e0513ab43d9b33be84a13946d5a@sentry.skypicker.com/71"

  window.Raven = Raven

  Raven.config(sentryUrl, {
    release: window.SP_GLOBALS.RELEASE_INFO.branch_slug,
    whitelistUrls: [
      /\.kiwi\.com\/scripts/,
      /manage\.kayak\.com\/scripts/,
      /kiwi\.wowair\.com\/scripts/,
    ],
    tags: {
      module: window.SP_GLOBALS.SKYPICKER_MODULE,
      pageName: window.SP_GLOBALS.SKYPICKER_PAGE_NAME,
      userId: window.SP_GLOBALS.SKYPICKER_VISITOR_UNIQID,
    },
  }).install()
}
